import { useMemo } from "react";
import { useSelector } from "react-redux";

const toInt = (v) => {
  if (v === null || v === undefined) return null;
  const n = typeof v === "number" ? v : parseInt(v, 10);
  return Number.isFinite(n) ? n : null;
};

/**
 * Child branch detector (UI restrictions).
 * A branch is considered a child when ParentComID (or parentComID) > 0.
 */

export default function useIsChildBranch() {
  const profileDataFromState = useSelector((state) => state?.auth?.profileData);
  const profileDataFromUser = useSelector((state) => state?.auth?.user?.profileData);

  const profileData = profileDataFromState || profileDataFromUser || null;

  return useMemo(() => {
    const parentComId = toInt(profileData?.ParentComID ?? profileData?.parentComID);
    return parentComId !== null && parentComId > 0;
  }, [profileData]);
}

